import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { roleColors } from '../../styles/theme';
import { UserRole } from '../../types';

interface RoleBadgeProps {
  role: UserRole;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  className?: string;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({
  role,
  size = 'small',
  variant = 'filled',
  className,
}) => {
  const colors = roleColors[role];

  return (
    <Tooltip title={`${role} account`} arrow>
      <Chip
        label={role}
        size={size}
        variant={variant}
        className={className}
        sx={{
          backgroundColor: variant === 'filled' ? colors.background : 'transparent',
          color: colors.text,
          border: variant === 'outlined' ? `1px solid ${colors.text}` : 'none',
          fontWeight: 600,
          fontSize: '0.75rem',
          height: size === 'small' ? 20 : 24,
          '& .MuiChip-label': {
            px: 1,
          },
        }}
      />
    </Tooltip>
  );
};

export default RoleBadge;